import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/common.css'
import 'normalize.css/normalize.css'
import '@/assets/icons/iconfont.css'
import devicePlugin from '@/utils/devicePlugin' // 判断设备
import { deviceMixin } from '@/mixin/deviceMixin'

console.log = function () {}
Vue.prototype.$eventBus = new Vue()

Vue.config.productionTip = false

Vue.use(ElementUI)
// Use devicePlugin
Vue.use(devicePlugin)
Vue.mixin(deviceMixin)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
